// extracted by mini-css-extract-plugin
export default {"card":"S--z"};